export enum InputType
{
    Number,
    Text,
    Select,
    ImageDropdown
}
